import React from 'react';
import { IInfoBanner } from '@kursk/components/pages/PushkinCard/PushkinCard';
import styles from '@kursk/components/pages/PushkinCard/InfoBlock/InfoBlock.module.scss';
import { useOrientations } from "@common/hooks/useOrientation";

interface InfoBlockCardProps {
  elements: IInfoBanner[]
}

export const InfoBlock = ({ elements }: InfoBlockCardProps) => {
  const orientation = useOrientations();
  const renderInfoCard = ({ type, src, srcButtons, link }: IInfoBanner) => {
    if (type === 'image') {
      return link ? <a href={link}
        className={styles.imagesCardAnchor}
        target="_blank"
        rel="noreferrer">
        <img key={src.desktop} className={styles.imagesCard} srcSet={src[orientation]}/>
      </a> :
        <img key={src.desktop} className={styles.imagesCard} srcSet={src[orientation]}/>
    }

    if (type === 'withButtons') {
      return (
        <div className={styles.infoBlockWithButtons}>
          <img key={src.desktop} className={styles.withButtonsImage} srcSet={src[orientation]}/>
          <div className={styles.buttonsWrapper}>
            {srcButtons.map(buttonProps => {
              return (
                <a
                  key={buttonProps.src}
                  href={buttonProps.link}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img className={styles.imageCardWithButtons} srcSet={buttonProps.src}/>
                </a>
              )
            })}
          </div>
        </div>
      )
    }
  }


  return (
    <div className={styles.infoWrapper}> {elements.map(element => {
      return renderInfoCard(element);
    })}
    </div>
  )
}
